import { render, staticRenderFns } from "./CmsProtectedClientsTable.vue?vue&type=template&id=a54aef2e&scoped=true"
import script from "./CmsProtectedClientsTable.vue?vue&type=script&lang=ts"
export * from "./CmsProtectedClientsTable.vue?vue&type=script&lang=ts"
import style0 from "./CmsProtectedClientsTable.vue?vue&type=style&index=0&id=a54aef2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54aef2e",
  null
  
)

export default component.exports